// extracted by mini-css-extract-plugin
module.exports = {"load-shedding-F":"F_load-shedding-F__SPA1s"};